var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2KeyboardDeletion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 21L.06 40l20.53 19H74V21H20.59zM70 55H22.16L5.94 40l16.22-15H70v30zm-36.41-8.41L40.18 40l-6.59-6.59 2.82-2.82L43 37.18l6.59-6.59 2.82 2.82L45.82 40l6.59 6.59-2.82 2.82L43 42.82l-6.59 6.59-2.82-2.82z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Keyboard_deletion.408c7611.svg";
export { SvgJ2KeyboardDeletion as ReactComponent };